module.exports = __webpack_public_path__ + "media/images/resource-placeholder06-3f85801143637e51980a75911398c8e2.jpg";